import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { toolsDetailsPartConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const ToolsDetailsPartStack = createStackNavigator();

const ToolsDetailsPartNavigator = () => {
  return (
    <ToolsDetailsPartStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {toolsDetailsPartConfig.map(({ Component, name }) => (
        <ToolsDetailsPartStack.Screen key={name} name={name} component={Component} />
      ))}
    </ToolsDetailsPartStack.Navigator>
  );
};

export { ToolsDetailsPartNavigator };
